"use client";

import React, { useState } from "react";
import { blogsApi } from "@/lib/api/services/blogs.api";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { ArrowLeft, Save, Loader2 } from "lucide-react";
import Link from "next/link";
import { toast } from "@/components/ui/toast";

export default function BlogWritePage() {
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [isSaving, setIsSaving] = useState(false);

  const handleSave = async () => {
    if (!title.trim() || !content.trim()) {
      toast({ type: "error", title: "Validation Error", message: "Title and content are required." });
      return;
    }
    setIsSaving(true);
    try {
      await blogsApi.create({ title, content, category: "General" });
      toast({ type: "success", title: "Blog post created", message: "Your blog post has been published." });
      setTitle("");
      setContent("");
    } catch {
      toast({ type: "error", title: "Error", message: "Failed to save blog post. Please try again." });
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Button variant="ghost" size="sm" asChild>
            <Link href="/blogs">
              <ArrowLeft className="mr-2 h-4 w-4" /> Back
            </Link>
          </Button>
        </div>
        <Button onClick={handleSave} disabled={isSaving}>
          {isSaving ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : <Save className="mr-2 h-4 w-4" />}
          Save
        </Button>
      </div>

      <h1 className="text-2xl font-bold text-foreground">Write Blog Post</h1>

      <Card>
        <CardContent className="p-6 space-y-4">
          <div>
            <label htmlFor="blog-title" className="block text-sm font-medium text-foreground mb-1">Title</label>
            <input
              id="blog-title"
              type="text"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              className="w-full rounded-md border border-border bg-background px-3 py-2 text-sm text-foreground placeholder:text-muted-foreground"
              placeholder="Enter blog post title"
            />
          </div>
          <div>
            <label htmlFor="blog-content" className="block text-sm font-medium text-foreground mb-1">Content</label>
            <textarea
              id="blog-content"
              value={content}
              onChange={(e) => setContent(e.target.value)}
              rows={20}
              className="w-full rounded-md border border-border bg-background px-3 py-2 text-sm text-foreground placeholder:text-muted-foreground"
              placeholder="Write your blog post content"
            />
          </div>
        </CardContent>
      </Card>
    </div>
  );
}